/* Namak Mirch — Trade landing page behaviour
   Header shadow + mobile menu, range band pause/play, cost-per-plate calculator,
   sort auto-submit, white label form validation. No dependencies. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var root = document.querySelector('.nm-trade');
  if (!root) return;

  /* ---------- Header: shadow when stuck, mobile menu closes on choice ---------- */
  var header = document.querySelector('.nm-tr-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var menu = header.querySelector('.nm-tr-menu');
    if (menu) {
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { menu.removeAttribute('open'); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.hasAttribute('open')) {
          menu.removeAttribute('open');
          menu.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', function (e) {
        if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
      });
    }
  }

  /* ---------- Range band: pause / play ---------- */
  document.querySelectorAll('.nm-tr-band').forEach(function (band) {
    var btn = band.querySelector('.nm-tr-band__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = band.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play the list of blends' : 'Pause the list of blends');
    });
  });

  /* ---------- Cost per plate calculator ---------- */
  var formatRs = function (n) {
    return 'Rs. ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var formatInt = function (n) { return n.toLocaleString('en-US'); };

  document.querySelectorAll('[data-trade-calculator]').forEach(function (calc) {
    var rates = {
      seasonings: parseFloat(calc.getAttribute('data-rate-seasonings')) || 5600,
      mixes: parseFloat(calc.getAttribute('data-rate-mixes')) || 2400
    };
    var copy = {
      seasonings: {
        inputLabel: 'Grams of seasoning per portion',
        start: 3,
        mainLabel: 'Seasoning cost per portion at the 1kg rate',
        yieldLabel: 'Portions from a 1kg pack',
        foot: 'Seasonings at ' + 'Rs. ' + formatInt(rates.seasonings) + ' per kg.'
      },
      mixes: {
        inputLabel: 'Grams of mix per kg of meat',
        start: 50,
        mainLabel: 'Mix cost per kg of meat at the 1kg rate',
        yieldLabel: 'Meat seasoned by a 1kg pack',
        foot: 'Recipe mixes at ' + 'Rs. ' + formatInt(rates.mixes) + ' per kg.'
      }
    };
    var radios = calc.querySelectorAll('input[type="radio"]');
    var grams = calc.querySelector('[data-calc-grams]');
    var inputLabel = calc.querySelector('[data-calc-input-label]');
    var mainLabel = calc.querySelector('[data-calc-main-label]');
    var main = calc.querySelector('[data-calc-main]');
    var ten = calc.querySelector('[data-calc-ten]');
    var yieldLabel = calc.querySelector('[data-calc-yield-label]');
    var yieldOut = calc.querySelector('[data-calc-yield]');
    var foot = calc.querySelector('[data-calc-foot]');
    var current = 'seasonings';

    var render = function () {
      var g = parseFloat(grams.value);
      var ok = isFinite(g) && g > 0;
      grams.setAttribute('aria-invalid', ok ? 'false' : 'true');
      var rate = rates[current];
      if (!ok) {
        main.textContent = '—';
        ten.textContent = '—';
        yieldOut.textContent = '—';
        return;
      }
      main.textContent = formatRs(rate * g / 1000);
      ten.textContent = formatRs(rate * 0.9 * g / 1000);
      if (current === 'seasonings') {
        yieldOut.textContent = formatInt(Math.floor(1000 / g));
      } else {
        yieldOut.textContent = (1000 / g).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' kg';
      }
    };

    var switchRange = function (range, resetValue) {
      current = range;
      var c = copy[range];
      inputLabel.textContent = c.inputLabel;
      mainLabel.textContent = c.mainLabel;
      yieldLabel.textContent = c.yieldLabel;
      foot.textContent = c.foot;
      if (resetValue) grams.value = c.start;
      render();
    };

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) switchRange(r.value, true); });
    });
    grams.addEventListener('input', render);
    var checked = calc.querySelector('input[type="radio"]:checked');
    switchRange(checked ? checked.value : 'seasonings', false);
  });

  /* ---------- Shop: sort applies as soon as it changes ---------- */
  document.querySelectorAll('[data-trade-sort]').forEach(function (form) {
    var select = form.querySelector('select');
    if (select) select.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- White label form: inline validation ---------- */
  document.querySelectorAll('[data-trade-enquiry]').forEach(function (form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-required]'));
    var submitted = false;

    var setError = function (input, show) {
      var field = input.closest('.nm-tr-form__field');
      var error = field.querySelector('.nm-tr-form__error');
      field.classList.toggle('has-error', show);
      input.setAttribute('aria-invalid', show ? 'true' : 'false');
      var described = (input.getAttribute('data-describedby') || '').trim();
      input.setAttribute('aria-describedby', show ? (error.id + (described ? ' ' + described : '')) : described || '');
      if (!input.getAttribute('aria-describedby')) input.removeAttribute('aria-describedby');
    };

    var validate = function (input) {
      var empty = !input.value.trim();
      setError(input, empty);
      return !empty;
    };

    fields.forEach(function (input) {
      input.addEventListener('blur', function () { if (submitted) validate(input); });
      input.addEventListener('input', function () { if (submitted) validate(input); });
    });

    form.addEventListener('submit', function (e) {
      submitted = true;
      var firstInvalid = null;
      fields.forEach(function (input) {
        if (!validate(input) && !firstInvalid) firstInvalid = input;
      });
      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
        return;
      }
      if (form.hasAttribute('data-demo')) {
        e.preventDefault();
        var wrap = form.closest('[data-trade-enquiry-wrap]');
        if (wrap) {
          wrap.querySelector('[data-enquiry-form]').hidden = true;
          var success = wrap.querySelector('[data-enquiry-success]');
          success.hidden = false;
          success.setAttribute('tabindex', '-1');
          success.focus();
        }
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Sending…'; }
    });
  });

  document.querySelectorAll('[data-enquiry-again]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var wrap = btn.closest('[data-trade-enquiry-wrap]');
      var formBox = wrap && wrap.querySelector('[data-enquiry-form]');
      if (!formBox) return;
      e.preventDefault();
      wrap.querySelector('[data-enquiry-success]').hidden = true;
      formBox.hidden = false;
      var form = formBox.querySelector('form');
      if (form) {
        form.reset();
        form.querySelectorAll('.has-error').forEach(function (f) { f.classList.remove('has-error'); });
        form.querySelectorAll('[aria-invalid]').forEach(function (i) { i.setAttribute('aria-invalid', 'false'); });
        var first = form.querySelector('input');
        if (first) first.focus();
      }
    });
  });
})();
